// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e2f3c421","453":"b30a9a3d","732":"feac5383"}[chunkId] + ".chunk.js";
};